<template>
	<div>
		<table class="my_table">
			<tbody>
				<tr>
					<td width="780">实时定位</td>
					<td>保存的定位</td>
				</tr>
				<tr>
					<td style="padding: 25px">
						对不起，暂时无法识别您的定位信息，您不在该区域内填写。对不起，根据您的定位信息，您不在该区域内填写。根据您的定位信息，您目前正处于该区域内填写。</td>
					<td>不在该区域内填写/在该区域内填写</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>

		export default {
			name: "Last",
	
			props: {
				work_task_id: {
					type: Number,
					default: 0
				},

				
			},
			data() {
				return {
  
				}
				}
			}
		

</script>

<style>
</style>
